import React from 'react';
import { useDurationAndTimeConfig } from '../../providers/durationAndTimeProvider';
import {
  useSelectedIds,
  useSelectedIdsActions,
} from '../../providers/selectedIdsProvider';
import SelectAcceptanceDuration from '../../../base/SelectAcceptanceDuration';
import { useSyncByIntervalTime } from '../../hooks/syncTime';
import { useFormWatch } from '../../../../../../helpers/formManager';
import SelectIntervalTime from '../../../base/SelectIntervalTime';
import { useTimeIntervals } from '../../../../services/timeIntervals';

const DurationAndTimeSelection = ({ index }) => {
  const { createDurationName, createIntervalIdName } =
    useDurationAndTimeConfig();

  const durationFieldName = createDurationName(index);
  const intervalIdFieldName = createIntervalIdName(index);

  const timeIntervals = useTimeIntervals();

  const { getSelectedIds } = useSelectedIdsActions();

  const { onChange } = useSelectedIdsActions();

  const syncTime = useSyncByIntervalTime(() => {
    return {
      fieldName: intervalIdFieldName,
      selectedIds: getSelectedIds(),
      controller: timeIntervals,
      onTimeChange: onChange,
    };
  });

  return (
    <div className="intervalInnerFlexContainer">
      <SelectAcceptanceDuration
        name={durationFieldName}
        durations={timeIntervals.durations}
        placeholder="Продолжительность"
        changeCb={syncTime}
      />
      <SelectTime
        durationFieldName={durationFieldName}
        fieldName={intervalIdFieldName}
        timeIntervals={timeIntervals}
      />
    </div>
  );
};

export default DurationAndTimeSelection;

function SelectTime({ durationFieldName, fieldName, timeIntervals }) {
  const duration = useFormWatch({ name: durationFieldName, exact: true });

  const options = timeIntervals.getTimesByDuration(duration);

  const selectedIds = useSelectedIds();

  const isAvailable = timeIntervals.createIsTimeAvailableFn({
    duration,
    selectedIds,
  });

  const { preparedOptions, hasAvailable } = prepareOptions(
    options,
    isAvailable
  );

  const { onChange } = useSelectedIdsActions();

  return (
    <SelectIntervalTime
      name={fieldName}
      placeholder="Начало интервала"
      requiredErrMsg="Укажите время начала"
      options={preparedOptions}
      hasDuration={Boolean(duration)}
      hasAvailableOptions={hasAvailable}
      onChange={onChange}
      allowClear
    />
  );
}

function prepareOptions(options, isAvailable) {
  let hasAvailable = false;

  const preparedOptions = options?.map((option) => {
    const disabled = !isAvailable(option) ?? false;

    if (!disabled) {
      hasAvailable = true;
    }

    return { option, disabled };
  });

  return { preparedOptions, hasAvailable };
}
